import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { leftPanleActiveTabInitialState } from "./initialState";

const leftPanleActiveTabSlice = createSlice({
  name: "leftPanelActiveTab",
  initialState: () => {
    const initialState = { ...leftPanleActiveTabInitialState };
    return initialState;
  },
  reducers: {
    setLPActiveTab(state, action: PayloadAction<string>) {
      state.leftPanleActiveTab = action.payload;
      return state;
    },

    setLPActiveTabStateName(state, action: PayloadAction<string>) {
      state.leftPanleActiveTabStateName = action.payload;
      return state;
    },
  },
});

export const { setLPActiveTab, setLPActiveTabStateName } =
  leftPanleActiveTabSlice.actions;

export default leftPanleActiveTabSlice;
